import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, inject } from '@angular/core';
import { EnvConfig, Environment } from '@doc/core';
import { Observable, of } from 'rxjs';
import { Lookups } from '../data';
import { ApiUrls } from '../document-urls';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  private http = inject(HttpClient);
  private apiUrl: string;
  private baseUrl: string;

  constructor(@Inject(EnvConfig) private config: Environment) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  uploadFile(formData: FormData): Observable<any> {
    const link = this.apiUrl + ApiUrls.uploadFile;
    const headers = new HttpHeaders({
      'X-Skip-Loader': 'true'
    });
    return this.http.post<any>(link, formData, { headers });
  }

  updateFile(formData: FormData): Observable<any> {
    const link = this.apiUrl + ApiUrls.updateFile;
    const headers = new HttpHeaders({
      'X-Skip-Loader': 'true'
    });
    return this.http.post<any>(link, formData, { headers });
  }

  getFileById(fileId: number): Observable<any> {
    const link = this.apiUrl + ApiUrls.getFileById + `/${fileId}`;
    return this.http.get<any>(link);
  }

  deleteFile(fileId: number): Observable<any> {
    const link = this.apiUrl + ApiUrls.deleteFile + fileId;
    return this.http.post<any>(link, {});
  }

  checkDuplicateFileNames(payload: {
    folderId: number;
    fileNames: string[];
    folderNames: string[];
    excludedFileId?: number;
  }): Observable<any> {
    const link = this.apiUrl + ApiUrls.checkDuplicateFileNames;
    const headers = new HttpHeaders({
      'X-Skip-Loader': 'true'
    });
    return this.http.post<any>(link, payload, { headers });
  }

  removeSharedFile(fileId: number): Observable<any> {
    const link = this.apiUrl + ApiUrls.removeSharedFile + fileId;
    return this.http.post<any>(link, {});
  }

  removeSharedFolder(folderId: number): Observable<any> {
    const link = this.apiUrl + ApiUrls.removeSharedFolder + folderId;
    return this.http.post<any>(link, {});
  }
  deleteSharedFile(fileId: number,isDepartmentShare:boolean): Observable<any> {
    const link = this.apiUrl + ApiUrls.removeSharedFile + fileId+'?isDepartmentShare='+isDepartmentShare;
    return this.http.post<any>(link, {});
  }

  deleteSharedFolder(folderId: number,isDepartmentShare:boolean): Observable<any> {
    const link = this.apiUrl + ApiUrls.removeSharedFolder + folderId+'?isDepartmentShare='+isDepartmentShare;
    return this.http.post<any>(link, {});
  }
}
